@if (cardHistory(); as penalties) {
  @if (penalties.totalPenalties) {
    <div class="or-bg-white border-radius-4 or-p-12-px card-box-shadow">
      <div (click)="changeVisibility()" class="or-d-flex or-justify-content-between or-align-items-center">
        <div class="or-head-sm">Historia kartek ({{ penalties.totalPenalties }})</div>
        <img src="assets/icons/chevron-up.svg" [class.or-rotate-180]="!isExpanded()" />
      </div>
      @if (isExpanded()) {
        <div class="or-mt-12-px">
          @for (
            penalty of penalties.groupedPenalties;
            track penalty.penaltyType;
            let i = $index, last = $last, first = $first
          ) {
            <div class="or-d-flex or-align-items-center" [class.or-mb-12-px]="!last || (first && !last)">
              <img
                [src]="cardReasonMapper[penalty.penaltyType].icon"
                class="or-align-self-start or-d-flex or-mr-8-px or-mt-2-px" />
              <div>
                <div class="or-text-md or-mb-4-px">
                  {{ cardReasonMapper[penalty.penaltyType].displayName }} ({{
                    penalties.groupedPenalties[i].penaltyDetails.length
                  }})
                </div>
                @for (
                  penaltyDetails of penalty.penaltyDetails;
                  track $index;
                  let lastItem = $last, firstItem = $first
                ) {
                  <div class="or-head-xs or-color-secondary-2" [class.or-mb-2-px]="!lastItem || firstItem">
                    {{ penaltyDetails.authorName }} - {{ penaltyDetails.createdAt }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
}
